class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.dialogContainer = this.querySelector('[role="dialog"]');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => {
        if (event.defaultPrevented || isComposingEvent(event)) return;
        if (event.key === 'Escape' || event.code?.toUpperCase() === 'ESCAPE') {
          event.stopPropagation();
          this.close();
        }
      }
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('[data-close-modal]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  connectedCallback() {
    if (this.isOpen() && this.summaryToggle.getAttribute('aria-expanded') !== 'true') {
      this.activateOpenState();
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('page-layout__overlay')) this.close(false);
  }

  open(event) {
    if (this.isOpen()) return;
    event.target.closest('details').setAttribute('open', true);
    this.activateOpenState();
  }

  activateOpenState() {
    this.dialogContainer.setAttribute('aria-modal', 'true');
    this.syncDocumentClass();

    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.summaryToggle.setAttribute('aria-expanded', 'true');
    document.body.addEventListener('click', this.onBodyClickEvent);

    trapFocus(this.dialogContainer, this.detailsContainer.querySelector('input:not([type="hidden"])'), this);
  }

  syncDocumentClass() {
    const className = this.dataset.documentClass;
    if (!className) return;
    const hasOpenOwner = Array.from(document.querySelectorAll('details-modal')).some(element =>
      element.dataset.documentClass === className && element.isOpen()
    );
    document.documentElement.classList.toggle(className, hasOpenOwner);
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;
    const handler = this.focusTrapHandler;
    const ownsTrap = handler && trapFocusHandlers.keydown === handler && trapFocusHandlers.container === this.dialogContainer;
    this.focusTrapHandler = null;
    const canReturnFocus = ownsTrap || (!handler && !trapFocusHandlers.container);
    this.detailsContainer.removeAttribute('open');
    this.dialogContainer.setAttribute('aria-modal', 'false');
    this.syncDocumentClass();
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (ownsTrap) {
      removeTrapFocus(focusToggle && this.summaryToggle.isConnected ? this.summaryToggle : null);
    } else if (canReturnFocus && focusToggle && this.summaryToggle.isConnected) {
      this.summaryToggle.focus();
    }
  }

  disconnectedCallback() {
    this.close(false);
  }
}

customElements.define('details-modal', DetailsModal);
